import Icon from '@ant-design/icons'
import { AntdIconProps } from '@ant-design/icons/lib/components/AntdIcon'
import { forwardRef } from 'react'
import { AntdCustomIconComponentProps } from '../typings/AntdCustomIconComponentProps'

const DocumentSvg = (props: AntdCustomIconComponentProps) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.21976 3.504L15.9088 3.5C18.2608 3.5 19.6648 4.942 19.6648 7.357V16.553C19.6648 18.951 18.2728 20.393 15.9448 20.407L8.25576 20.41C5.90476 20.41 4.49976 18.968 4.49976 16.553V7.357C4.49976 4.958 5.89176 3.518 8.21976 3.504ZM2.99976 16.553C2.99976 19.757 5.11276 21.91 8.25676 21.91L15.9498 21.907C19.1178 21.887 21.1648 19.785 21.1648 16.553V7.357C21.1648 4.153 19.0528 2 15.9088 2H15.9078L8.21476 2.004C5.04676 2.023 2.99976 4.124 2.99976 7.357V16.553ZM11.2505 8.61035H8.49548C8.08148 8.61035 7.74548 8.27435 7.74548 7.86035C7.74548 7.44635 8.08148 7.11035 8.49548 7.11035H11.2505C11.6645 7.11035 12.0005 7.44635 12.0005 7.86035C12.0005 8.27435 11.6645 8.61035 11.2505 8.61035ZM8.49585 12.7872H15.7158C16.1298 12.7872 16.4658 12.4512 16.4658 12.0372C16.4658 11.6232 16.1298 11.2872 15.7158 11.2872H8.49585C8.08185 11.2872 7.74585 11.6232 7.74585 12.0372C7.74585 12.4512 8.08185 12.7872 8.49585 12.7872ZM8.49585 16.9738H15.7158C16.1298 16.9738 16.4658 16.6378 16.4658 16.2238C16.4658 15.8098 16.1298 15.4738 15.7158 15.4738H8.49585C8.08185 15.4738 7.74585 15.8098 7.74585 16.2238C7.74585 16.6378 8.08185 16.9738 8.49585 16.9738Z"
    />
  </svg>
)

export const Document = forwardRef<HTMLSpanElement, AntdIconProps>(
  (props, ref) => <Icon component={DocumentSvg} {...props} ref={ref} />
)
